module.exports = __webpack_public_path__ + "img/updateimg06.6a9a622b.png";